<template>
  <vx-card :no-shadow="no_shadow">
    <vx-timeline :timelineData="timelineData" />
    <infinite-loading v-if="timelineMeta.has_next" @infinite="getMoreActivityLog" spinner="circles">
      <div slot="no-results"></div>
    </infinite-loading>
  </vx-card>
</template>

<script>
import { getActivityList } from '@/api/activityLog'
import vxTimeline from './VxTimeline.vue'

export default {
  name: 'activityTimeline',
  props: ['staff_id', 'no_shadow', 'new_activity'],
  components: {
    vxTimeline
  },
  data () {
    return {
      staffId: this.staff_id,
      timelineData: [],
      timelineMeta: {
        total: null,
        limit: null,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: null
      }
    }
  },
  created () {
    this.getActivityLog()
  },
  watch: {
    staff_id (new_value) {
      this.staffId = new_value
      this.timelineData = []
      this.timelineMeta = {
        total: null,
        limit: null,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: null
      }

      this.getActivityLog()
    },
    new_activity (new_value) {
      this.timelineData.unshift({ ...new_value })
    }
  },
  methods: {
    async getActivityLog () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.staffId,
        platform_module_id: 2
      }

      try {
        const response = await getActivityList(payload)
        this.timelineData = response.data.data.activity
        this.timelineMeta = response.data.data.meta

      } catch (e) {
        console.log(e)
      }
    },
    async getMoreActivityLog ($state) {
      if (this.timelineMeta.has_next) {
        const payload = {
          customer_id: localStorage.getItem('customer_id'),
          entity_id: this.staffId,
          platform_module_id: 2
        }
        
        try {
          const response = await getActivityList(payload, this.timelineMeta.next_page_url)
          this.timelineData.push(...response.data.data.activity)
          this.timelineMeta = response.data.data.meta

          if (!this.timelineMeta.has_next) {
            $state.complete()
          } else {
            $state.loaded()
          }
        } catch (e) {
          console.log(e)
        }
      } else  {
        $state.complete()
      }
    }
  }
}
</script>
